import { css, StyleSheet } from 'aphrodite'
import DeleteIcon from '../svgs/DeleteIcon'

const DeleteButton = ({ clickHandler }) => {
	return (
		<button className={css(styles.btn)} onClick={clickHandler}>
			<DeleteIcon />
		</button>
	)
}

export default DeleteButton

const styles = StyleSheet.create({
	btn: {
		background: 'none',
		border: 0,
		outline: 0,
		padding: 0,
		':hover': {
			cursor: 'pointer',
		},
	},
})
